import { render, staticRenderFns } from "./PhotoSeries.vue?vue&type=template&id=57a8939a&scoped=true"
import script from "./PhotoSeries.vue?vue&type=script&lang=js"
export * from "./PhotoSeries.vue?vue&type=script&lang=js"
import style0 from "./PhotoSeries.vue?vue&type=style&index=0&id=57a8939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8939a",
  null
  
)

export default component.exports